export default class JsonLdAdapter {
  adapt(data) {
    const transformedData = Object.assign(Object.assign({}, data), {
      '@context': 'http://schema.org'
    });
    return JSON.stringify(transformedData, null, 2);
  }
}